import i18n from '@/lang/i18n'
export default {
  list_faq: [],
  last_page: 0,
  total: 0,
  faq_select: {
    faq: {},
    comment: {}
  },
  fields: [
    {
      key: 'title',
      label: i18n.t('forum.attribute.title')
    },
    {
      key: 'views',
      label: i18n.t('forum.attribute.view')
    },
    {
      key: 'replies',
      label: i18n.t('forum.attribute.replies')
    },
    {
      key: 'created_at',
      label: i18n.t('forum.attribute.created_at')
    },
    {
      key: 'status',
      label: i18n.t('forum.attribute.status')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/module/faq/state.js